module.exports = __webpack_public_path__ + "img/car.95411458.svg";